import React from 'react'
import {API_BASE_URL, CLIENT_LIST_PAGE_SIZE} from '../../constants'
import axios from 'axios'

import ReactTable  from "react-table";
import {getToken,  setLocalKeyValue, getLocalKeyValue} from '../../storage'
import SearchInput from '../search/search'
import {validateGSTIN} from '../../utils/misc'
import {updateHistory} from '../commons/functions'
export default class ClientList extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: null,
      loading: true,
      client_search: props.location.state ? (props.location.state.client_search || null): null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreate = this.goToCreate.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    document.title = "Client List"
  }


  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  downloadClients = () => {


    let apiurl = "/export_clients_excel/";



    this.downloadReport(apiurl).then((response)=> {


      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {

      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }


  goToCreate(e) {
    e.preventDefault()
    this.props.history.push("/clients/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/clients/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  handleSearchInput(q) {
    this.fetchData(this.state.tableState, null, q)
    updateHistory(this.props, {client_search:q})
  }

  validateGSTIN(row) {
    if(row.original.gstin) {
      if(validateGSTIN(row.original.gstin)) {
        return row.original.gstin
      }
      else {
        return <div className="text-danger">{row.original.gstin}</div>
      }
    }
  }

    fetchData(state, instance, query=this.state.client_search) {
      this.setState({ loading: true });
      setLocalKeyValue(CLIENT_LIST_PAGE_SIZE, state.pageSize)
      let apiurl = "/list_clients/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      if(query) {
        apiurl = apiurl + "&q="+query
      }
      this.setState({tableState:state, client_search:query})
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.clients,
          pages: res.data.pages,
          loading: false
        });
      });
    }

    dueAmountFormat =(row)=>{
      return <div className="text-right">{row.original.balance_amount}</div>
    }


    render() {
      const { data, pages, loading } = this.state;
      const columns = [

        {Header:'Name', accessor: 'name',sortable:true },
        {Header:'GSTIN', accessor: 'gstin',sortable:true, Cell:(row)=>{return this.validateGSTIN(row)} },
        {Header:'Phone', accessor: 'phone',sortable:true },
        {Header:'Due Amount', accessor:'balance_amount', sortable:true, Cell:(row)=>{return this.dueAmountFormat(row)}},
        {Header:'Address', accessor: 'address'},
        {Header:'City', accessor: 'city'}
      ]
      const defaultSort=[{id: "id", desc: true}]

      let pageSize = getLocalKeyValue(CLIENT_LIST_PAGE_SIZE)

      if(typeof pageSize === "undefined"){
        pageSize = 20
      }
      else {
        pageSize = parseInt(pageSize, 10)
      }

      return <div><section className="medium">

          <div className="row">
          <div className="col-md-3">
          <button onClick={this.goToCreate} className="btn btn-primary">Create New Client</button>
          </div>
              <div className="col-md-3">
                <SearchInput value={this.state.client_search} handleSearchInput={this.handleSearchInput} placeholder={"Search Clients"} />
              </div>
          </div>

      </section>
      <div className="row mbottom">
        <div className="col-sm-12">

        <div className="row">

            <div className="col-xs-12">
              <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadClients()}}>Download xls</button></div>
            </div>
        </div>
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Clients Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/client/clientlistnew.js